/**
 * CSS mix-blend-mode dropdown values
 * @module mixBlendModes
 */

const mixBlendModes = [
  'normal',
  'multiply',
  'screen',
  'overlay',
  'darken',
  'lighten',
  'color-dodge',
  'color-burn',
  'hard-light',
  'soft-light',
  'difference',
  'exclusion',
  'hue',
  'saturation',
  'color',
  'luminosity'
].sort()

export default mixBlendModes



// WEBPACK FOOTER //
// ./src/helpers/mix-blend-modes.js